import { useTranslation } from 'react-i18next';

/**
 * Simple safe translation hook that handles missing keys gracefully
 * @param {string} key - Translation key
 * @param {string} fallback - Fallback text if translation is not ready
 * @returns {string} - Translated text or fallback
 */
export const useSafeTranslation = (key, fallback = 'Dashboard') => {
  const { t } = useTranslation('dashboard');
  
  const translation = t(key, { defaultValue: null });
  
  // If translation exists and is not the same as the key, return it
  if (translation && translation !== key) {
    return translation;
  }
  
  // Return fallback if translation is not available
  return fallback;
};

export default useSafeTranslation;